import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-steel">
    <span className="inline-block h-2 w-2 rotate-45 bg-brand" />
    {children}
  </p>
);

export default Reveal;
